module.exports = __webpack_public_path__ + "media/images/product_lines/car/info2_m-01c7db6bd58b039a8a66d77758c679c2.svg";